import { createSelector } from 'reselect';
import requirementsSelector from '../../AppointmentRequirementsSelector';
import { ADDRESS_FORM_STATE_KEY } from '../../constants';

const addressFormSelector = createSelector(
    requirementsSelector,
    (requirements) => requirements[ADDRESS_FORM_STATE_KEY]
);

export default addressFormSelector;
